/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './calendar.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '../../../../../src/app/shared/calendar/calendar.component';
const styles_CalendarComponent:any[] = [i0.styles];
export const RenderType_CalendarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CalendarComponent,data:{}});
function View_CalendarComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'external-event']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.title;
    _ck(_v,1,0,currVal_0);
  });
}
function View_CalendarComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'external-events']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'h4',[['class',
      'external-events__title']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['Draggable Events'])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CalendarComponent_2)),
      i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),7,'label',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),5,'input',[['type','checkbox']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,7).onChange($event.target.checked)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,7).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.removeAfterDrop = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.CheckboxControlValueAccessor,
          [i1.Renderer,i1.ElementRef],(null as any),(null as any)),i1.ɵprd(1024,(null as any),
          i3.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i3.CheckboxControlValueAccessor]),i1.ɵdid(671744,(null as any),0,i3.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(16384,(null as any),0,i3.NgControlStatus,
          [i3.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          [' Remove after drop']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.events;
    _ck(_v,4,0,currVal_0);
    const currVal_8:any = _co.removeAfterDrop;
    _ck(_v,9,0,currVal_8);
  },(_ck,_v) => {
    const currVal_1:any = i1.ɵnov(_v,11).ngClassUntouched;
    const currVal_2:any = i1.ɵnov(_v,11).ngClassTouched;
    const currVal_3:any = i1.ɵnov(_v,11).ngClassPristine;
    const currVal_4:any = i1.ɵnov(_v,11).ngClassDirty;
    const currVal_5:any = i1.ɵnov(_v,11).ngClassValid;
    const currVal_6:any = i1.ɵnov(_v,11).ngClassInvalid;
    const currVal_7:any = i1.ɵnov(_v,11).ngClassPending;
    _ck(_v,6,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_CalendarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{calendarEl:0}),(_l()(),i1.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_CalendarComponent_1)),i1.ɵdid(16384,(null as any),
      0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵeld(0,[[1,0],['calendar',1]],(null as any),0,'div',[['class','calendar']],
          (null as any),(null as any),(null as any),(null as any),(null as any)))],
      (_ck,_v) => {
        var _co:i4.CalendarComponent = _v.component;
        const currVal_0:any = _co.external;
        _ck(_v,2,0,currVal_0);
      },(null as any));
}
export function View_CalendarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-calendar',
      ([] as any[]),(null as any),(null as any),(null as any),View_CalendarComponent_0,
      RenderType_CalendarComponent)),i1.ɵdid(4374528,(null as any),0,i4.CalendarComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const CalendarComponentNgFactory:i1.ComponentFactory<i4.CalendarComponent> = i1.ɵccf('admin-calendar',
    i4.CalendarComponent,View_CalendarComponent_Host_0,{events:'events',defaultDate:'defaultDate',
        external:'external'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NhbGVuZGFyL2NhbGVuZGFyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9jYWxlbmRhci9jYWxlbmRhci5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL3NoYXJlZC9jYWxlbmRhci9jYWxlbmRhci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NhbGVuZGFyL2NhbGVuZGFyLmNvbXBvbmVudC50cy5DYWxlbmRhckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJleHRlcm5hbC1ldmVudHNcIiAqbmdJZj1cImV4dGVybmFsXCI+PGg0IGNsYXNzPVwiZXh0ZXJuYWwtZXZlbnRzX190aXRsZVwiPkRyYWdnYWJsZSBFdmVudHM8L2g0PjxkaXYgY2xhc3M9XCJleHRlcm5hbC1ldmVudFwiICpuZ0Zvcj1cImxldCBldnQgb2YgZXZlbnRzXCI+e3tldnQudGl0bGV9fTwvZGl2PjxsYWJlbD48aW5wdXQgdHlwZT1cImNoZWNrYm94XCIgWyhuZ01vZGVsKV09XCJyZW1vdmVBZnRlckRyb3BcIj4gUmVtb3ZlIGFmdGVyIGRyb3A8L2xhYmVsPjwvZGl2PjxkaXYgI2NhbGVuZGFyIGNsYXNzPVwiY2FsZW5kYXJcIj48L2Rpdj4iLCI8YWRtaW4tY2FsZW5kYXI+PC9hZG1pbi1jYWxlbmRhcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBc0c7TUFBQTtNQUF1RDtJQUFBO0lBQUE7Ozs7b0JBQTdKO01BQUE7TUFBQSxnQkFBOEM7TUFBQTtNQUFBLGdCQUFtQyxxREFBcUI7YUFBQTthQUFBOzRCQUFBLHlDQUEwRTtVQUFBO1VBQUEsNENBQU87VUFBQTtjQUFBO2tCQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQXVCO2NBQUE7Y0FBQTtZQUFBO1lBQXZCO1VBQUEsdUNBQUE7VUFBQSxnRUFBQTsrQkFBQTtZQUFBO1VBQUEsNENBQUE7VUFBQTtVQUFBLHFEQUFBO3VCQUFBLG1DQUFBO1VBQUEsNENBQXFEO1VBQUE7O0lBQTFHO0lBQTVCLFdBQTRCLFNBQTVCO0lBQXdHO0lBQXZCLFdBQXVCLFNBQXZCOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSxxRUFBQTs7Ozt3REFBdkw7TUFBQSxnRUFBQTtNQUFBO01BQTRRO1VBQUE7OztRQUEvTztRQUE3QixXQUE2QixTQUE3Qjs7OztvQkNBQTtNQUFBO2tDQUFBLFVBQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/calendar/calendar.component.ngfactory.ts